<template>
    <div class="MyClient" v-wechat-title="$route.meta.title">
        <div class="back">
            <van-sticky>
                <van-search class="search" placeholder="请输入搜索关键词" v-model="key" shape="round" />

                <van-dropdown-menu class="menu_wrap" active-color="#1E90FF">

                    <van-dropdown-item v-model="foldIndex" :options="foldList" @change="resetList" />

                    <van-dropdown-item :title="sortList[sortIndex].text + (sortList[sortIndex].is_asc ? '升序' : '降序')"
                        ref="item">

                        <van-cell center @click="changeSort(index)" :title="item.text + (item.is_asc ? '升序' : '降序')"
                            v-for="(item, index) in sortList" :key="index">
                            <template #right-icon>
                                <van-icon :color="item.active ? '#1E90FF' : ''" name="ascending" v-if="item.is_asc" />

                                <van-icon :color="item.active ? '#1E90FF' : ''" name="descending" v-else />
                            </template>
                        </van-cell>

                    </van-dropdown-item>

                </van-dropdown-menu>

            </van-sticky>

            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <div class="list">

                    <van-list v-model="loading" :finished="finished" :finished-text="finishedtext" @load="onLoad">

                        <van-empty v-show="Total == 0" description="暂无信息" />

                        <div class="list_item" v-for="(item, index) in list" :key="index">
                            <div class="card_type" :class="{ 'active': item.islooked }"
                                @click="changeCardType(item.id, index)">
                                {{ item.islooked ? '已读' : '未读' }}</div>
                            <div class="row">
                                <div class="item">客户：{{ item.name }}</div>
                                <div class="item">电话：{{ item.phonenumber }}</div>
                            </div>
                            <div class="row" v-show="item.squaremeters">
                                <div class="item">面积：{{ item.squaremeters }}m²</div>
                                <!-- <div class="item" v-show="item.Remark!=''">户型：{{item.Remark}}</div> -->
                            </div>
                            <div class="row village" v-show="item.residentialname">小区：{{ item.residentialname }}</div>
                            <div class="details"><span>来源页面：</span>
                                <a :href="item.url && item.url.includes('wx38dd2f98af9b0a80') ? '' : item.url">{{ item.url
                                    }}</a>

                                <wx-open-launch-weapp v-if="item.url && item.url.includes('wx38dd2f98af9b0a80')"
                                    username="gh_1b943db9de6c"
                                    :path="item.url && item.url.replace('wx38dd2f98af9b0a80/', '')">

                                    <script type="text/wxtag-template">
                                        <style>
                                            .btn{width:100%;height:30px;}
                                        </style>
                                        <div class="btn"></div>
                                    </script>
                                </wx-open-launch-weapp>
                            </div>
                            <div class="row">
                                <span>客户备注：</span><img @click="editShow(index)" class="icon_edit"
                                    src="@/assets/img/edit.png" alt="">
                            </div>
                            <div class="row edit" v-show="item.remark">{{ item.remark }}</div>
                            <div class="row remarks">
                                <div class="rate">
                                    客户意向
                                    <van-rate class="client_rate" v-model="item.infoquality" @change="setRate(index)"
                                        icon="like" void-icon="like" />
                                </div>
                                <a :href="'tel:' + item.phonenumber" @click="maidian(item.phonenumber)">
                                    <div class="button">拨号</div>
                                </a>
                            </div>
                        </div>

                    </van-list>

                </div>
            </van-pull-refresh>
        </div>

        <van-popup class="client_modal" v-model="show" :close-on-click-overlay="false">

            <div class="edit_title">客户备注</div>
            <div class="edit_con">
                <textarea placeholder="备注客户需求~~" v-model="edit"></textarea>
            </div>
            <div class="edit_foot">

                <div class="cancel" @click="cancel">取消</div>
                <div class="confirm" @click="confirm">确认</div>
            </div>
        </van-popup>

        <wxsdk :isHidden="true" :config="wxconfig"></wxsdk>
    </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from 'vuex'; //先要引入
import { Toast } from 'vant';
import { delay } from '@/util/util'


export default {
    name: 'MyClient',
    data() {
        return {
            foldIndex: 0,
            sortIndex: 0,
            foldList: [
                { text: '全部', value: 0 },
                { text: '五星', value: 5 },
                { text: '四星', value: 4 },
                { text: '三星', value: 3 },
                { text: '二星', value: 2 },
                { text: '一星', value: 1 },
            ],
            sortList: [
                { text: '时间', value: 'datecreated', is_asc: false, active: true },
                { text: '面积', value: 'squaremeters', is_asc: false, active: false },
                // { text: '获客排序', value: 'rc' },
            ],
            wxconfig: {
                title: '业之峰环保装饰', // 分享标题
                link: window.location.href.split('#')[0], // 分享链接
                desc: '诺云出品，营销神器', // 分享描述
                imgUrl: 'https://picfw.yzf.com.cn/shadow/20200215084744', // 分享图标
            },

            list: [],
            loading: false,
            finished: false,
            // rate: 3,
            // tel: 13589898989,
            show: false,
            edit: '', //用户填写的备注
            index: '', //卡片索引
            page: 0,
            key: '', //查询关键字
            Total: 0,
            InfoQuality: '', //查询星级
            isLoading: false,

        }
    },
    computed: {
        ...mapState({
        }),
        finishedtext() {
            if (this.Total == 0) {
                return ''
            } else {
                return '没有更多了'
            }
        }

    },
    components: {
        wxsdk: () => import('@/components/Wxsdk.vue')
    },
    watch: {
        //监听搜索，拉取数据
        key() {

            delay(() => {

                this.resetList()
            }, 300);
        },
    },
    created() { },
    mounted() { },
    methods: {
        // 改变排序
        changeSort(index) {
            if (index == this.sortIndex) {
                this.sortList[index].is_asc = !this.sortList[index].is_asc
            }

            this.sortIndex = index

            this.sortList.forEach((e, i) => {
                if (i == index) {
                    e.active = true
                } else {
                    e.active = false
                }
            })


            this.$refs.item.toggle();

            this.$nextTick(() => {
                this.resetList()
            })
        },
        async onRefresh() {

            await this.resetList()

            this.isLoading = false;

            Toast.success({
                message: '刷新成功'
            })

        },
        async resetList() {
            this.page = 0
            this.list = []
            this.finished = false
            this.onLoad()
        },
        maidian(tel) {
            window._hmt.push(['_trackEvent', '线索', '拨号', window.location.origin + window.location.pathname, tel]);
        },
        changeCardType(id, index) {
            var data = {
                id: id
            }
            this.$put('/api/Registration/IsLooked', data).then((res) => {
                // console.log(res)
                if (res.Success) {
                    this.list[index].islooked = true
                }
            }).catch((err) => { })
        },
        //更改星级
        setRate(index) {
            var data = {}
            data.id = this.list[index].id
            data.infoquality = this.list[index].infoquality
            // console.log(data)
            this.$put('/api/Registration/PutQuality', data).then((res) => {
                if (res.Success) {
                    // that.list[that.index].remark = data.remark
                    Toast.success({

                        message: '修改成功'
                    });
                }
            }).catch((err) => { })
        },
        cancel() {
            this.edit = ''
            this.show = !this.show
        },
        confirm() {
            var that = this
            if (this.edit != '') {
                var data = {}
                data.id = this.list[this.index].id;
                data.remark = this.edit
                this.$put('/api/Registration/Put', data).then((response) => {
                    if (response.Success) {
                        that.list[that.index].remark = data.remark
                        Toast.success({

                            message: '修改成功'
                        });
                    }
                }).catch((err) => { })
            }
            this.edit = '' //用户编辑的备注置空
            this.show = !this.show
        },
        editShow(index) {
            this.index = index;
            this.edit = this.list[index].remark
            this.show = true

        },
        async onLoad() {
            this.page += 1
            // 异步更新数据
            await this.getData()
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成

            if (this.list.length >= this.Total) {
                this.finished = true;
            }


        },
        //拉取数据
        getData() {
            var params = {
                is_paging: true, //是否分页
                order_property: this.sortList[this.sortIndex].value, //排序字段
                is_asc: this.sortList[this.sortIndex].is_asc, //正序
                page_size: 10, //每页条数
                page: this.page, //页码
                key: this.key, //查询关键字
                InfoQuality: this.foldIndex ? this.foldIndex : '', //星级
            };

            // console.log(params)
            return new Promise((resolve, reject) => {
                this.$get('/api/Registration/Get', params).then((res) => {
                    if (res.Success) {
                        // console.log(res)
                        this.list = [...this.list, ...res.Object.Data]

                        this.Total = res.Object.Total;
                        resolve()
                    } else {
                        reject()
                    }
                }).catch((res) => {
                    this.error = true;
                    reject()
                })
            })

        }
    }
}
</script>
<style lang="scss" scoped>
.MyClient {
    .back {
        background: #efefef;
        width: 100vw;
        min-height: 100vh;



        .menu_wrap {
            margin-top: -1px;
        }


        .list {
            padding-bottom: 50px;

            .list_item {
                margin: 20px;
                margin-bottom: 20px;
                background: #ffffff;
                border-radius: 20px;
                box-shadow: 0px 10px 20px 2px #dddddd;
                padding: 30px;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                text-align: left;
                position: relative;

                .card_type {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    background: #f44;
                    color: #ffffff;
                    height: 52px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 52px;
                    padding: 0 20px;
                    font-size: 22px;
                    transition: all .3s;

                    &.active {
                        background: rgb(189, 189, 189);
                    }
                }

                .row {
                    display: flex;
                    flex-direction: row;
                    font-size: 26px;
                    color: #343434;
                    height: 26px;
                    line-height: 26px;
                    margin-bottom: 24px;

                    &.village {
                        margin-bottom: 60px;
                    }

                    &.remarks {
                        justify-content: space-between;
                        height: auto;
                        overflow: hidden;
                        align-items: center;
                        margin-bottom: 0;

                        .rate {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            color: #999999;

                            .client_rate {
                                margin-left: 20px;
                            }
                        }

                        .button {
                            width: 140px;
                            height: 52px;
                            color: #ffffff;
                            font-size: 26px;
                            line-height: 52px;
                            text-align: center;
                            border-radius: 52px;
                            background: #1E90FF;
                        }
                    }

                    .item {
                        flex: 1;

                        &:last-child {
                            padding-right: 50px;
                        }
                    }

                    .icon_edit {
                        width: 141px;
                        height: 26px;
                    }

                    &.edit {
                        color: #666666;
                        height: auto;
                    }
                }

                .details {
                    position: relative;
                    line-height: 46px;
                    font-size: 26px;
                    color: #343434;
                    vertical-align: top;
                    margin-bottom: 24px;
                    z-index: 1;

                    wx-open-launch-weapp {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        overflow: hidden;
                        z-index: 2;
                        opacity: 0;
                    }

                    a {
                        color: #1E90FF;
                        word-wrap: break-word;

                        &:active {
                            color: #1E90FF;
                        }
                    }
                }





            }
        }
    }

    .client_modal {
        width: 600px;
        border-radius: 20px;

        .edit_title {
            text-align: center;
            font-size: 34px;
            font-weight: 600;
            padding: 43px;
            border-bottom: 1px solid #ebebeb;
        }

        .edit_con {
            border-bottom: 1px solid #ebebeb;
            padding: 50px;
            width: 500px;
            height: 120px;

            textarea {
                border: 0;
                outline: none;
                resize: none;
                width: 100%;
                height: 100%;
            }
        }

        .edit_foot {
            display: flex;
            flex-direction: row;

            div {
                flex: 1;
                text-align: center;
                font-size: 30px;
                color: #666666;
                padding: 35px;

                &.confirm {
                    border-left: 1px solid #ebebeb;
                    color: #1E90FF;
                }

            }
        }
    }

}
</style>